(function () {

  function slugify(text) {
    return text
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }


  function initArticleGuide(root) {

    if (!root || root.dataset.articleGuideInitialized === 'true') {
      return;
    }

    root.dataset.articleGuideInitialized = 'true';
    
    initFinderPopup(root);


    const body =
      root.querySelector('[data-article-body]');

    const toc =
      root.querySelector('[data-article-toc]');

    const tocList =
      root.querySelector('[data-article-toc-list]');


    if (!body || !toc || !tocList) {
      return;
    }


    const headings =
  Array.from(
    body.querySelectorAll('h2')
  ).filter((heading) => {

    if (heading.hasAttribute('data-no-toc')) {
      return false;
    }

    if (heading.hasAttribute('data-toc-include')) {
      return true;
    }

    return !heading.closest('.article-guide__wide');

  });


    if (!headings.length) {
      return;
    }


    const usedIds = new Set();


    headings.forEach((heading, index) => {

      let baseId =
        heading.id ||
        slugify(heading.textContent) ||
        `section-${index + 1}`;

      let finalId = baseId;
      let suffix = 2;


      while (usedIds.has(finalId)) {
        finalId = `${baseId}-${suffix}`;
        suffix += 1;
      }


      usedIds.add(finalId);
      heading.id = finalId;


      const item =
        document.createElement('li');

      const link =
        document.createElement('a');


      link.href = `#${finalId}`;
      link.textContent =
        heading.textContent.trim();


      item.appendChild(link);
      tocList.appendChild(item);
    });


    toc.hidden = false;
  }

  function initFinderPopup(root) {

  const popup =
    root.querySelector(
      '[data-article-finder-popup]'
    );

  if (!popup) {
    return;
  }


  const body =
    root.querySelector(
      '[data-article-body]'
    );

  if (!body) {
    return;
  }


  const articleId =
    popup.dataset.articleId || 'article';

  const storageKey =
    `lbcFinderPopupSeen-${articleId}`;


  let hasOpened = false;


  try {

    if (
      sessionStorage.getItem(storageKey) === 'true'
    ) {
      hasOpened = true;
    }

  } catch (error) {
    // Le popup fonctionne même si sessionStorage
    // n'est pas disponible.
  }


  function getReadingProgress() {

    const bodyTop =
      body.getBoundingClientRect().top +
      window.scrollY;

    const bodyHeight =
      body.offsetHeight;

    if (!bodyHeight) {
      return 0;
    }


    const readingPosition =
      window.scrollY +
      (window.innerHeight * 0.5);

    return (
      readingPosition - bodyTop
    ) / bodyHeight;

  }


  function openPopup() {

    if (hasOpened) {
      return;
    }

    hasOpened = true;

    popup.hidden = false;

    document.body.classList.add(
      'article-finder-popup-open'
    );


    try {

      sessionStorage.setItem(
        storageKey,
        'true'
      );

    } catch (error) {
      // Pas bloquant.
    }


    window.removeEventListener(
      'scroll',
      handleScroll
    );

  }


  function closePopup() {

    popup.hidden = true;

    document.body.classList.remove(
      'article-finder-popup-open'
    );

  }


  function handleScroll() {

    if (hasOpened) {
      return;
    }


    if (getReadingProgress() >= 0.20) {
      openPopup();
    }

  }


  popup
    .querySelectorAll(
      '[data-finder-popup-close]'
    )
    .forEach((element) => {

      element.addEventListener(
        'click',
        closePopup
      );

    });


  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape' &&
        !popup.hidden
      ) {
        closePopup();
      }

    }
  );


  window.addEventListener(
    'scroll',
    handleScroll,
    { passive: true }
  );


  handleScroll();

}

  function initAll() {

    document
      .querySelectorAll('[data-article-guide]')
      .forEach(initArticleGuide);

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }


  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const root =
        event.target.querySelector(
          '[data-article-guide]'
        );

      if (root) {
        initArticleGuide(root);
      }

    }
  );

})();